// extracted by mini-css-extract-plugin
export default {"averageRow":"o44eG408N05Z0sl_Aaew"};